import { createFileRoute } from "@tanstack/react-router";
import { errorPath } from "lib/routeHelpers";
import { useEffect } from "react";
import { useAppNavigate } from "ui/hooks/useAppNavigate";
import withAuthentication from "../../components/withAuthentication";

function DebugError403() {
  const navigate = useAppNavigate();

  useEffect(() => {
    void navigate({ to: errorPath(403, "/debug/error-403", "Testing 403 redirect!") });
  }, []);

  return <div>This should not render!</div>;
}

export const Route = createFileRoute("/debug/error-403")({
  component: withAuthentication(DebugError403, { superAdmin: true }),
});
